import { render, staticRenderFns } from "./ItemForSelect.vue?vue&type=template&id=19542e5e&"
import script from "./ItemForSelect.vue?vue&type=script&lang=js&"
export * from "./ItemForSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports